import * as lib from '~/dependencies';

export const Label = lib.styled.span`
    color: #6e6e6e !important;
    font-weight: bold;
    margin-right: 5px;
`;

export const Container = lib.styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;

    .date-time {
        margin-top: 5px;
        font-size: 10px;
        color: #6e6e6e;
    }

    .email-title {
        color: #6e6e6e;
        margin-top: 10px;
    }

    .email-body {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 5px;
        text-align: justify;
        color: #ccced2
    }

    .customize-clip {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .MuiChip-colorPrimary {
            background-color: #78bb5d !important;
            font-size: 10px !important;
        }

        .MuiChip-sizeSmall {
            margin-left: 5px;
            height: 15px !important;
        }
    }
`;
